import { render, staticRenderFns } from "./torunament_edit_v2.vue?vue&type=template&id=5ca7c69c&"
import script from "./torunament_edit_v2.vue?vue&type=script&lang=js&"
export * from "./torunament_edit_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports